// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_472ac2', '__Inter_Fallback_472ac2'","fontStyle":"normal"},"className":"__className_472ac2","variable":"__variable_472ac2"};